export default __webpack_public_path__ + "static/AppBeers2-6836c6b9ba8f2cbe674b164f98424cc7.png";